import React, { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient.js";
import "../../styles/ReceiveWax.css";

const CastingDone = () => {
  const [grouped, setGrouped] = useState({});
  const [loading, setLoading] = useState(true);
  const [openDates, setOpenDates] = useState({}); // NEW

  const toggleDate = (date) => {
    setOpenDates((prev) => ({
      ...prev,
      [date]: !prev[date],
    }));
  };

  useEffect(() => {
    loadCastingDone();
  }, []);

  async function loadCastingDone() {
    setLoading(true);

    try {
      const { data, error } = await supabase
        .from("casting_done")
        .select(`
          id,
          casting_date,
          gain_loss,
          lot_id,
          lot_no,
          item_id,
          wax_item:WAX_ITEMS(
            id,
            item_id,
            design_code,
            gross_weight,
            net_weight,
            pieces_count,
            ITEMS:item_id(item_name)
          )
        `)
        .order("casting_date", { ascending: false })
        .order("lot_no", { ascending: true });

      if (error) {
        console.error("Error loading casting_done:", error);
        return;
      }

      const result = {};

      (data || []).forEach((row) => {
        const dateKey = row.casting_date || "Unknown";

        if (!result[dateKey]) {
          result[dateKey] = {
            lots: {},
            total_gain: 0,
          };
        }

        const lotKey = row.lot_no || "Unknown Lot";

        if (!result[dateKey].lots[lotKey]) {
          result[dateKey].lots[lotKey] = {
            lot_no: lotKey,
            items: [],
          };
        }

        result[dateKey].lots[lotKey].items.push({
          id: row.id,
          gain_loss: row.gain_loss,
          wax_item: row.wax_item,
        });

        result[dateKey].total_gain += Number(row.gain_loss || 0);
      });

      setGrouped(result);
    } catch (err) {
      console.error("Unexpected error:", err);
    }

    setLoading(false);
  }

  if (loading) return <p>Loading Casting Done Records...</p>;

  return (
    <div className="receive-container">
      <h2 className="page-title">Casting Done</h2>

      {Object.keys(grouped).length === 0 && (
        <p>No casting done records.</p>
      )}

      {Object.keys(grouped).map((dateKey) => {
        const day = grouped[dateKey];
        const lots = Object.values(day.lots);

        return (
          <div key={dateKey} style={{ marginBottom: 32 }}>
            
            {/* COLLAPSIBLE DATE HEADER */}
            <h3
              onClick={() => toggleDate(dateKey)}
              style={{
                background: "#ffe9c2",
                padding: 12,
                borderRadius: 6,
                border: "1px solid #e0b472",
                marginBottom: 12,
                cursor: "pointer",
                userSelect: "none",
              }}
            >
              {openDates[dateKey] ? "▼" : "▶"} {dateKey}
            </h3>

            {/* SHOW LOTS ONLY WHEN DATE IS OPEN */}
            {openDates[dateKey] &&
              lots.map((lotGroup, i) => (
                <div className="lot-card" key={i} style={{ marginBottom: 12 }}>
                  <table className="wax-table">
                    <thead>
                      <tr>
                        <th colSpan="6" style={{ textAlign: "left", fontWeight: "bold" }}>
                          Lot No: {lotGroup.lot_no}
                        </th>
                      </tr>
                      <tr>
                        <th>Item</th>
                        <th>Design</th>
                        <th>Gross</th>
                        <th>Net</th>
                        <th>Pcs</th>
                        <th>Gain/Loss</th>
                      </tr>
                    </thead>

                    <tbody>
                      {lotGroup.items.map((it, idx) => (
                        <tr key={idx}>
                          <td>{it.wax_item?.ITEMS?.item_name ?? "-"}</td>
                          <td>{it.wax_item?.design_code ?? "-"}</td>
                          <td>{it.wax_item?.gross_weight ?? "-"}</td>
                          <td>{it.wax_item?.net_weight ?? "-"}</td>
                          <td>{it.wax_item?.pieces_count ?? "-"}</td>
                          <td
                            style={{
                              color: (it.gain_loss ?? 0) >= 0 ? "green" : "red",
                              fontWeight: 600,
                            }}
                          >
                            {it.gain_loss ?? 0}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ))}

            {/* DAILY TOTAL */}
            {openDates[dateKey] && (
              <div
                style={{
                  marginTop: 10,
                  padding: 12,
                  background: "#fff3d6",
                  borderRadius: 6,
                  border: "1px solid #e0c48f",
                  textAlign: "right",
                  fontWeight: 700,
                }}
              >
                Total Gain/Loss for {dateKey}:{" "}
                <span style={{ color: day.total_gain >= 0 ? "green" : "red" }}>
                  {day.total_gain.toFixed(3)}
                </span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CastingDone;
